export const MULTI_ROLE_OPERATOR = 'Multi-Role Operator';
export const LOADER_SALTING_OPERATOR = 'Loader + Salting Operator';
export const HEAVY_EQUIPMENT_OPERATOR = 'Heavy Equipment Plow Operator';
export const SNOWEDGE_OPERATOR = 'SnowEdge Operator';
export const SITE_SUPERVISOR = 'Site Supervisor/HEO';
export const LEGACY_SITE_SUPERVISOR = 'Site Supervisor/Loader Operator';
// Old stored name -> its replacement. The old name keeps its eligibility until staff are renamed by hand.
export const RENAMED_POSITIONS = { [LEGACY_SITE_SUPERVISOR]: SITE_SUPERVISOR };
const LEGACY_POSITIONS = Object.keys(RENAMED_POSITIONS);
const isCurrent = position => !LEGACY_POSITIONS.includes(position);

export const WALKWAY_POSITIONS = ['Crew Leader', 'Crew Member', MULTI_ROLE_OPERATOR];
// Eligibility checks recognize old names; CURRENT_LOADER_POSITIONS is for display.
export const LOADER_POSITIONS = ['Loader Operator', SITE_SUPERVISOR, LEGACY_SITE_SUPERVISOR, HEAVY_EQUIPMENT_OPERATOR, SNOWEDGE_OPERATOR, MULTI_ROLE_OPERATOR, LOADER_SALTING_OPERATOR];
export const CURRENT_LOADER_POSITIONS = LOADER_POSITIONS.filter(isCurrent);
export const SALTING_POSITIONS = ['Salt Truck Driver', MULTI_ROLE_OPERATOR, LOADER_SALTING_OPERATOR];
// Positions offered when creating staff or choosing a new role.
export const STAFF_POSITIONS = [...new Set([
  ...WALKWAY_POSITIONS,
  ...CURRENT_LOADER_POSITIONS,
  ...SALTING_POSITIONS,
  'Territory Manager',
  'Office',
  'Working Site Supervisor',
])];
// Lists each given old name directly after its replacement.
const withOldNames = oldNames => STAFF_POSITIONS.flatMap(position => [
  position, ...oldNames.filter(oldName => RENAMED_POSITIONS[oldName] === position),
]);
// Filters also find staff still holding an old name.
export const STAFF_POSITION_FILTERS = withOldNames(LEGACY_POSITIONS);

// Selectable roles for an existing record: its old name stays listed until changed.
export const editablePositions = current => withOldNames(RENAMED_POSITIONS[current] ? [current] : []);

export const hasMultiRoleAssignment = (staff) => staff.position === MULTI_ROLE_OPERATOR
  && Boolean(staff.assigned_bool || staff.assigned_walkway_crew_bool || staff.assigned_salting_route_bool);

export const MULTI_ROLE_ASSIGNMENT_HINT = 'Remove the current loader, walkway crew, or salting route assignment first.';
